import React from 'react';
import SolutionPublishEstimateWaitContainer from 'containers/SolutionPublishEstimateWaitContainer/SolutionPublishEstimateWaitContainer';

export default function SolutionPublishEstimateWaitPage() {
    return (
        <SolutionPublishEstimateWaitContainer />
    )
}
